import api from "../api/axios";

export const getWallet = async (id) => {
  try {
    const response = await api.get(`/wallet/${id}`);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Add server response details to the error
      error.message = `${
        error.response.data.error || error.response.statusText
      }`;
    } else if (error.request) {
      // Add request details to the error
      error.message = "No response received from server.";
    } else {
      // Add request setup details to the error
      error.message = `${error.message}`;
    }
    throw error;
  }
};

export const getGroupWallet = async (groupId) => {
  try {
    const response = await api.get(`/wallet/group/${groupId}`);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Add server response details to the error
      error.message = `${
        error.response.data.error || error.response.statusText
      }`;
    } else if (error.request) {
      // Add request details to the error
      error.message = "No response received from server.";
    } else {
      // Add request setup details to the error
      error.message = `${error.message}`;
    }
    throw error;
  }
};

export const updateKegowData = async (groupId, payload) => {
  try {
    const response = await api.post(`/wallet/${groupId}/update-kegow-account`, payload);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Add server response details to the error
      error.message = `${
        error.response.data.error || error.response.statusText
      }`;
    } else if (error.request) {
      // Add request details to the error
      error.message = "No response received from server.";
    } else {
      // Add request setup details to the error
      error.message = `${error.message}`;
    }
    throw error;
  }
};

export const getSubWallets = async (groupId) => {
  try {
    // Note: Adjust this endpoint string if your legacy route for fetching sub-wallets is different
    const response = await api.get(`/sub-wallet/group/${groupId}`); 
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};